import React from 'react';
import { useApp } from '../../context/AppContext';
import './Admin.css';

const AdminPanel = () => {
  const { user, courts, judges, advocates, users, cases, hearings, documents, judgments, resetToMockData } = useApp();

  if (user?.role !== 'Admin' && user?.role !== 'Clerk') {
    return (
      <div className="admin-container">
        <div className="access-denied">
          <h1>🔐 Access Denied</h1>
          <p>You do not have permission to access this page.</p>
        </div>
      </div>
    );
  }

  const stats = [
    { label: 'Total Courts', value: courts.length, icon: '📂' },
    { label: 'Total Judges', value: judges.length, icon: '👨‍⚖️' },
    { label: 'Total Advocates', value: advocates.length, icon: '👨‍💼' },
    { label: 'Total Users', value: users.length, icon: '👤' },
    { label: 'Total Cases', value: cases.length, icon: '📁' },
    { label: 'Total Hearings', value: hearings.length, icon: '📅' },
    { label: 'Total Documents', value: documents.length, icon: '📄' },
    { label: 'Total Judgments', value: judgments.length, icon: '⚖️' },
  ];

  return (
    <div className="admin-container">
      <div className="admin-header">
        <h1>🔐 Admin Panel</h1>
        <p>System Administration and Overview</p>
      </div>

      <div className="admin-stats-grid">
        {stats.map((stat, index) => (
          <div key={index} className="admin-stat-card">
            <div className="admin-stat-icon">{stat.icon}</div>
            <div className="admin-stat-content">
              <div className="admin-stat-value">{stat.value}</div>
              <div className="admin-stat-label">{stat.label}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="admin-sections">
        <div className="admin-section-card">
          <h2>System Information</h2>
          <div className="info-grid">
            <div className="info-item">
              <strong>Application Name:</strong> e-Court Management System
            </div>
            <div className="info-item">
              <strong>Version:</strong> 1.0.0
            </div>
            <div className="info-item">
              <strong>Current User:</strong> {user?.username} ({user?.role})
            </div>
            <div className="info-item">
              <strong>Data Storage:</strong> LocalStorage (Browser)
            </div>
          </div>
        </div>

        <div className="admin-section-card">
          <h2>Quick Actions</h2>
          <div className="quick-actions">
            <div className="action-item">
              <span className="action-icon">📊</span>
              <div>
                <strong>View Reports</strong>
                <p>Access comprehensive system reports</p>
              </div>
            </div>
            <div className="action-item">
              <span className="action-icon">📋</span>
              <div>
                <strong>Audit Logs</strong>
                <p>View system activity and audit trail</p>
              </div>
            </div>
            <div className="action-item">
              <span className="action-icon">👤</span>
              <div>
                <strong>User Management</strong>
                <p>Manage system users and permissions</p>
              </div>
            </div>
            <div className="action-item">
              <span className="action-icon">⚙️</span>
              <div>
                <strong>System Settings</strong>
                <p>Configure system parameters</p>
              </div>
            </div>
          </div>
        </div>

        <div className="admin-section-card">
          <h2>Data Management</h2>
          <div className="data-management">
            <p>Reset system to load mock data. This will clear all current data and reload sample data.</p>
            <button 
              onClick={() => {
                if (window.confirm('Are you sure you want to reset all data and load mock data? This action cannot be undone.')) {
                  resetToMockData();
                  window.location.reload();
                }
              }}
              className="btn-reset"
            >
              🔄 Reset to Mock Data
            </button>
            <small>Note: This will clear all existing data and reload sample data</small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;

